export const VAULT_REFETCH_INTERVAL = 5 * 60 * 1000; // 5 minutes
